<app-eca-modal-host [heading]="getHeadingFromOperative()"
                    (saveClicked)="saveOperative()"
                    (editClicked)="editOperative()"
                    (cancelClicked)="cancelClicked()"
                    (helpClicked)="helpClicked()"
                    [isEditing]="editing || isNewOperative"
                    [yesButtonIcon]="['far', 'save']"
                    [noButtonIcon]="['far', 'times']"
                    [editButtonIcon]="['far', 'edit']"
                    noButtonColour="transparent">
  <div class="container">
    <div class="row" *ngIf="showingHelp">
      <div class="col">
        <div class="alert alert-info">
          <div class="container-fluid">
            <div class="row">
              <div class="col-auto">
                <fa-icon [icon]="['far', 'question-circle']" size="4x">  </fa-icon>
              </div>
              <div class="col">
                <p>{{helpMessage}}</p>
              </div>
              <div class="col-auto">
                <fa-icon [icon]="['far', 'times']" class="close" (click)="helpClicked()">  </fa-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-operative-editor class="eca-secondary-bg"
                              [operative]="operative"
                              [allOperativeTypes]="allOperativeTypes"
                              [allBusinessUnits]="allBusinessUnits"
                              [allJobTitles]="allJobTitles"
                              [allCompanyJobTitles]="allCompanyJobTitles"
                              [allJobLevels]="allJobLevels"
                              [allRisks]="allRisks"
                              [saveAttempted]="submitted"
                              [isNewOperative]="isNewOperative"
                              [allEmploymentStatuses]="allEmploymentStatuses">
        </app-operative-editor>
      </div>
    </div>
  </div>
</app-eca-modal-host>
